import { Button, Form, FormInstance, Input } from 'antd';
import { setStoredInput } from 'presentation/redux/features/CU/CU03101Slice';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import React from 'react';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { CountStep } from './CountStep';
import { InputRadioOption, InputSelectOption } from './Input';

interface props {
    form: FormInstance<any>;
}
export const StepTwo = ({ form }: props) => {
    const toiletBathOptions = useAppSelector((state) => state.CU03101Slice.toiletBathOptions);
    const roomlayoutDivOptions = useAppSelector((state) => state.CU03101Slice.roomlayoutDivOptions);
    const laundryAreaOptions = useAppSelector((state) => state.CU03101Slice.laundryAreaOptions);
    const dispatch = useAppDispatch();
    const storedInput = useAppSelector((state) => state.CU03101Slice.storedInput);
    const disabledBTN = useAppSelector((state) => state.CU03101Slice.disabledBTN);

    const convertOptionsType = (
        value: any[],
    ): { value: number | string; name: number | string }[] => {
        const result: { value: number | string; name: number | string }[] = value.map(
            (element: any) => {
                return {
                    value: element.code,
                    name: element.codeName,
                };
            },
        );

        return result;
    };

    const onNext = () => {
        const newStoredInput = {
            ...storedInput,
            roomLayoutDiv: form.getFieldValue('roomLayoutDiv'),
            bathToiletSeparatedDiv: form.getFieldValue('bathToiletSeparatedDiv'),
            indoorLaundryRoomDiv: form.getFieldValue('indoorLaundryRoomDiv'),
            notes: form.getFieldValue('notes'),
            page: 2,
            submit:
                form.getFieldValue('roomLayoutDiv') &&
                form.getFieldValue('bathToiletSeparatedDiv') &&
                form.getFieldValue('indoorLaundryRoomDiv') &&
                true,
            prev: false,
        };
        dispatch(setStoredInput(newStoredInput));
    };

    const onBack = () => {
        const newStoredInput = {
            ...storedInput,
            page: 2,
            prev: true,
            submit: true,
        };
        dispatch(setStoredInput(newStoredInput));
    };

    return (
        <React.Fragment>
            <CountStep current={2} title="部屋情報を入力してください。" />

            <InputSelectOption
                label="間取り"
                name="roomLayoutDiv"
                isRequired
                requiredMessage={getMessage('Sel_Required', '間取り')}
                placeholder={PLACEHOLDER.SELECT}
                options={convertOptionsType(roomlayoutDivOptions)}
            />
            <InputRadioOption
                label="バス・トイレ"
                name="bathToiletSeparatedDiv"
                requiredMessage={getMessage('In_Required', 'バス・トイレ')}
                isRequired
                options={convertOptionsType(toiletBathOptions)}
            />
            <InputRadioOption
                label="室内洗濯機置き場"
                name="indoorLaundryRoomDiv"
                requiredMessage={getMessage('In_Required', '室内洗濯機置き場')}
                isRequired
                options={convertOptionsType(laundryAreaOptions)}
            />
            <section style={{ width: '100%', marginTop: 24 }} className="input-number-custom">
                <div style={{ marginBottom: 16 }} className="label-form">
                    備考（任意）
                </div>
                <Form.Item
                    required={false}
                    className="input-font-style-2 label-form-style "
                    name="notes"
                    label={false}
                >
                    <Input.TextArea
                        maxLength={10000}
                        style={{ height: 160, resize: 'none' }}
                        placeholder={PLACEHOLDER.PEOPERTY_NOTES}
                    />
                </Form.Item>
            </section>
            <section
                style={{
                    width: '100%',
                    justifyContent: 'space-between',
                    display: 'flex',
                }}
            >
                <Button
                    className="button-login-text"
                    style={{
                        width: 165.5,
                        height: 56,
                        marginTop: 16,
                        color: '#28323C',
                    }}
                    onClick={() => onBack()}
                >
                    戻る
                </Button>
                <Button
                    type="primary"
                    className="button-login-text"
                    style={{ width: 165.5, height: 56, marginTop: 16 }}
                    onClick={() => onNext()}
                    htmlType="submit"
                >
                    次へ
                </Button>
            </section>
        </React.Fragment>
    );
};
